import styled from 'styled-components';
import { Button } from 'antd';
import { fontColor, buttonPrimaryBgColor, white, primaryHoverColor, warning, warningFont, warningHover } from 'Public/Css/colors';

export default styled(Button) `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    letter-spacing: .2px;
    font-size: 1.0rem;
    line-height: 1;
    padding: 8px 12px;
    border-radius: 999px;

    >span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    &.noneStyle {
        background-color: transparent;
        border: none;
        padding: 0;
        box-shadow: none;
        margin: 0;
        height: auto;
        display: inline;;
    }

    &[disabled], &[disabled]:hover {
        opacity: 0.7;
        background-color: ${buttonPrimaryBgColor};
        border-color: ${buttonPrimaryBgColor};
    }

    a {
        color: ${white};
    }

    &.create {
        color: ${buttonPrimaryBgColor};
        font-weight: bold;
        border-color: ${buttonPrimaryBgColor};
        box-shadow: none;
        background-color: ${white};
        margin-left: 20px;
    }

    &.small {
        height: 20px;
        padding: 0 10px;
        margin-bottom: 0;
        line-height: 1;
    }
    
    &.danger {
        background-color: ${warning};
        border-color: ${warning};
        color: ${warningFont};

        &:hover {
            background-color: ${warningHover} !important;
            border-color: ${warningHover};
            color: ${white};
        }
    }
`;
